import { render, staticRenderFns } from "./InvestmentValuation.vue?vue&type=template&id=5c96358e"
import script from "./InvestmentValuation.vue?vue&type=script&lang=js"
export * from "./InvestmentValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports